import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/services/auth.service';
import { CptTimeAssociationDialogComponent } from '../cpt-time-association-dialog/cpt-time-association-dialog.component';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { lastValueFrom } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { TemplateExplorerService } from '../templates/template-explorer/template-explorer.service';

@Component({
  selector: 'app-cpt-time-association',
  templateUrl: './cpt-time-association.component.html',
  styleUrls: ['./cpt-time-association.component.css']
})
export class CptTimeAssociationComponent implements OnInit {
  public CptTimeAssociationDialogComponent;
  currentUser : any;
  company_id: any;
  loaderId = 'cpt-time-association-loader';
  relations: any;
  dataSource: any;
  cptCodesDropdownSettings: any = {};
  displayedColumns = ['time','codes'];
  cpts: any;
  data : any;
  isEditing = false;
  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private loader: NgxUiLoaderService,
    private authService : AuthService,
    private companyService: CompanyService,
    private templateExplorerService: TemplateExplorerService,

  ) { 
    this.currentUser = this.authService.currentUser;
    this.cptCodesDropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'codeDescription',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }

  async ngOnInit() {
    this.company_id = this.route.parent.snapshot.params.id;
    this.loader.startLoader(this.loaderId);
    await this.initcptCodes();
    await this.initRelations();
    this.loader.stopLoader(this.loaderId);

  }

  async initcptCodes() {
    return new Promise<void>((resolve, reject) => {
      this.templateExplorerService.getAllCPTs().subscribe((response: any) => {
        if (response.status == 200) {
          this.cpts = response.data;
          resolve();
        } else {
          this.toastr.error('Something went wrong!', 'Error');
        }
      }, err => {
        reject();
        this.toastr.error('Something went wrong!', 'Error');
      });
    })
  }

  openDialog() {
    this.CptTimeAssociationDialogComponent = this.dialog.open(CptTimeAssociationDialogComponent,
      {
        width: '50%',
        height: '50%',
        data: this.company_id
      }).afterClosed().subscribe(async (data: any) => {
        if (data) {
          this.loader.startLoader(this.loaderId);
          this.initRelations();
          this.toastr.success('Association created!', 'Success');
          this.loader.stopLoader(this.loaderId);
        }
      });
  }

  async initRelations() {
    this.loader.startLoader(this.loaderId);
    let response = await lastValueFrom(this.companyService.getCptTimeAssociations(this.company_id))
    if(response['status'] == 200) {
      this.relations = response['data'];
      this.relations.forEach(relation => {
        relation.isEditing = false;
      });
      this.dataSource = this.relations;
    }
    this.loader.stopLoader(this.loaderId);
  }

  async onCodeSelect(element, $event) {
    let isCreating = true;
    let cpts = [];
    cpts.push($event._id);
    await this.updateCptTimeRelation(element._id, this.company_id, cpts, isCreating);
  }

  async onCodeDeSelect(element, $event) {
    let isCreating = false;
    let cpts = [];
    cpts.push($event._id);
    await this.updateCptTimeRelation(element._id, this.company_id, cpts, isCreating);
  }

  async updateCptTimeRelation(_id, companyId, cptId, isCreating: boolean) {
    this.companyService.updateCptTimeRelation(_id, companyId, cptId, isCreating).subscribe((res: any) => {
      if (res.status == 200) {
        this.toastr.success('Relation Updated!', 'Success');
      } else {
        this.toastr.error('Something went wrong!', 'Error');
      }
    });
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${this.padZero(minutes)}:${this.padZero(secs)}`;
  }

  padZero(num: number): string {
    return num < 10 ? `0${num}` : num.toString();
  }
  
  onEdit(element) {
    element.start_time_minutes = element.start_time / 60;
    element.end_time_minutes = element.end_time / 60;
    element.isEditing = true;
  }

  convertToSeconds(minutes: number): number {
    return minutes * 60;
  }

  async onSave(element) {
    if (element.start_time_minutes * 60 > element.end_time_minutes * 60) {
      this.toastr.error('Start time cannot be greater than end time!', 'Error');
      return;
    }
    element.start_time = element.start_time_minutes * 60;
    element.end_time = element.end_time_minutes * 60;
    element.isEditing = false;
    let model = {
      startTime: element.start_time,
      endTime: element.end_time,
      _id: element._id
    };
    const updateTime = await lastValueFrom(this.companyService.createCptTimeRelation(this.company_id, model));
    if (updateTime['status'] == 200) {
      this.toastr.success('Updated Successfully!', 'Success');
    } else {
      this.toastr.error('Something went wrong!', 'Error');
    }
  }
}
